import { type FollowUpPeriodRestrictionLegacy } from '@verantos-dev/types-cohorts';
import { Cohort_definitionContext } from '@verantos-dev/util-cohort-builder-typescript-runtime';

export const generateFollowUp = (
  cohortDefinitionTree: Cohort_definitionContext
): FollowUpPeriodRestrictionLegacy | undefined => {
  if (!cohortDefinitionTree.follow_up_period_criteria) return undefined;

  const followUpPeriodRestriction = cohortDefinitionTree
    ?.follow_up_period_criteria()
    ?.follow_up_period();

  return {
    isEnabled: true,
    daysAfterIndexDate: parseInt(followUpPeriodRestriction?.INT()?.getText() || '0'),
  };
};
